import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import './App.css';
import CssBaseline from '@material-ui/core/CssBaseline';

import { ThemeProvider } from '@material-ui/styles';
import theme from './config/muiOverrides';

import { About, FieldCheck, Dashboard, Hotspot, 
         InteractiveManagement, NotAllowed, NotFound, 
         Progression, Simulation, Slider,
         Timeline, Login, User, Users } from './pages';
import ProtectedRoute from "./components/ProtectedRoute";

export default function App() {

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}
        <Switch>
          
          <ProtectedRoute path="/field-check/:id?" component={FieldCheck}/>
          <ProtectedRoute path="/hotspot/:id?" component={Hotspot}/>
          <ProtectedRoute path="/progression/:id?" component={Progression}/>
          <ProtectedRoute path="/simulation/:id?" component={Simulation}/>
          <ProtectedRoute path="/slider/:id?" component={Slider}/>
          <ProtectedRoute path="/timeline/:id?" component={Timeline}/>

          <ProtectedRoute path={"/interactives/"} component={InteractiveManagement} adminRoute />

          <Route path="/login" component={Login}/>
          <ProtectedRoute path="/users" component={Users} adminRoute />
          <ProtectedRoute path={`/user/:userId?`} component={User} adminRoute />

          <Route path="/not-allowed" component={NotAllowed}/>
          <Route path="/not-found" component={NotFound}/>

          <ProtectedRoute path="/about/" component={About}/>
          <ProtectedRoute path="/" component={Dashboard} />
        </Switch>
      </Router>
    </ThemeProvider>
  );
}
